import styled from "styled-components"

export const ListGroupsContainer = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 1rem;
    font-family: MontserratRegular;
`
